var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"originInfo"},[_c('QS-h4-title',{attrs:{"title":"来源信息"}}),_vm._v(" "),_c('form-text-box',{ref:"FormTextBox",attrs:{"dataList":_vm.dataList,"column":3,"model":_vm.carLease_obj,"rules":_vm.carLease_obj_rules}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }